/**
 * SOJ Core Modern - Main JavaScript Entry Point
 *
 * This file is ready for site-specific JavaScript code.
 * All core functionality is handled by core.js and its modules.
 *
 * @package SOJ_Core_Modern
 * @since 2.0.0
 * @author Son of Jesse
 */

// Import core functionality (this will initialize all modules)
import core from './core.js';

// Import utilities if needed for site-specific code
import { utils, events, dom, log } from './modules/utilities.js';

// Import animation systems
import AnimationSystem from './modules/animations.js';
import GSAPAnimationSystem from './modules/gsap-animations.js';

// Import and expose GSAP globally for block scripts
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register ScrollTrigger and expose GSAP globally
gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

// Register DrawSVGPlugin when available (loaded via CDN)
// Wait for it to load and register with GSAP
if (typeof window.DrawSVGPlugin !== 'undefined') {
    gsap.registerPlugin(window.DrawSVGPlugin);
    console.log('[GSAP] DrawSVGPlugin registered');
} else {
    // Poll for DrawSVGPlugin if not immediately available
    const checkDrawSVG = setInterval(() => {
        if (typeof window.DrawSVGPlugin !== 'undefined') {
            clearInterval(checkDrawSVG);
            gsap.registerPlugin(window.DrawSVGPlugin);
            console.log('[GSAP] DrawSVGPlugin registered (delayed)');
        }
    }, 100);
    // Stop checking after 5 seconds
    setTimeout(() => clearInterval(checkDrawSVG), 5000);
}

// Initialize animation systems
let animationSystem;
let gsapAnimationSystem;

document.addEventListener('DOMContentLoaded', function() {
    // Initialize scroll-triggered animations (CSS-based)
    animationSystem = new AnimationSystem();

    // Initialize GSAP animations
    gsapAnimationSystem = new GSAPAnimationSystem();

    // Make animation systems available globally for dynamic content
    window.SOJ_ANIMATIONS = animationSystem;
    window.SOJ_GSAP_ANIMATIONS = gsapAnimationSystem;

    console.log('[SOJ] Animation systems loaded (CSS + GSAP)');
});

